import { render, staticRenderFns } from "./LMSDashboardLinkWithDescription.vue?vue&type=template&id=0e7ead70&scoped=true"
import script from "./LMSDashboardLinkWithDescription.vue?vue&type=script&lang=ts"
export * from "./LMSDashboardLinkWithDescription.vue?vue&type=script&lang=ts"
import style0 from "./LMSDashboardLinkWithDescription.vue?vue&type=style&index=0&id=0e7ead70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e7ead70",
  null
  
)

export default component.exports